import React, { useState } from 'react';
import '../../../css/EditCouponModal.css';
import api from '../../../api/axiosConfig';
import { showToast } from '../../Shared/Toaster';

interface Props {
  coupon: any;
  onClose: () => void;
  onUpdate: () => void;
}

const EditCouponModal: React.FC<Props> = ({ coupon, onClose, onUpdate }) => {
  const [formData, setFormData] = useState({
    code: coupon.code,
    code_type: coupon.code_type,
    valid_from: formatDateForInput(coupon.valid_from),
    valid_until: formatDateForInput(coupon.valid_until),
    fee_discount: coupon.fee_discount || '',
    redemption_limit: coupon.redemption_limit || '',
  });

  function formatDateForInput(dateStr: string) {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toISOString().split('T')[0];
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const token = sessionStorage.getItem("accessToken");
      if (!token) {
        showToast("Authentication error: You are not logged in.", 'error');
        return;
      }

      const payload = {
        ...formData,
        fee_discount: Number(formData.fee_discount) || 0,
        redemption_limit: formData.redemption_limit ? Number(formData.redemption_limit) : null,
      };

      await api.payment_api.put(`/admin/promocodes/${coupon.promo_code_id}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      showToast("Coupon updated successfully!", 'success');
      onUpdate();
      onClose();
    } catch (error) {
      console.error('Error updating coupon:', error);
      showToast('Failed to update coupon. Please check the console for details.', 'error');
    }
  };

  return (
    <div className="edit-coupon-modal-overlay" onClick={onClose}>
      <div className="edit-coupon-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Edit Coupon Code</h3>
          <button type="button" className="global-close-btn" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="edit-coupon-field">
            <label>Coupon Code</label>
            <input
              type="text"
              name="code"
              value={formData.code}
              onChange={handleChange}
              required
            />
          </div>

          <div className="edit-coupon-field">
            <label>Code Type</label>
            <select
              name="code_type"
              value={formData.code_type}
              onChange={handleChange}
              required
            >
              <option value="PROMO">Promo code</option>
              <option value="VENUE">Venue</option>
            </select>
          </div>

          <div className="edit-coupon-card">
            <label className="card-title">Validity Period</label>
            <div className="edit-coupon-row">
              <div>
                <label>Start Date</label>
                <input
                  type="date"
                  name="valid_from"
                  value={formData.valid_from}
                  onChange={handleChange}
                  required
                />
              </div>
              <div>
                <label>End Date</label>
                <input
                  type="date"
                  name="valid_until"
                  value={formData.valid_until}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          </div>

          <div className="edit-coupon-field">
            <label>Fee Discount (₹)</label>
            <input
              type="number"
              name="fee_discount"
              value={formData.fee_discount}
              onChange={handleChange}
              min="0"
            />
          </div>

          <div className="edit-coupon-field">
            <label>Redemption Limit (leave empty for unlimited)</label>
            <input
              type="number"
              name="redemption_limit"
              value={formData.redemption_limit}
              onChange={handleChange}
              min="1"
            />
          </div>

          <div className="edit-coupon-actions">
            <button type="button" className="edit-coupon-cancel-btn" onClick={onClose}>Cancel</button>
            <button type="submit" className="edit-coupon-save-btn">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditCouponModal;
